import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import NewJob from './pages/NewJob';
import Machines from './pages/Machines';
import Rules from './pages/Rules';
import Settings from './pages/Settings';
import { useStore } from './store';
import { selectTemplate, matchMachines } from './engine/rules';

// Seed 6 real Sturdfix reference parts on first launch
const SEEDS = [
  { customer:'APA Engineering',  part_no:'54-96B',           description:'Cylinder Head Bolt M12×1.75×132 Gr 10.9',
    part:{ part_type:'BOLT', nominal_diameter_mm:12, thread_pitch_mm:1.75, total_length_mm:132, shank_length_mm:100, head_type:'HEX_SOCKET', socket_type:'HEX_SOCKET', wire_diameter_mm:11.71, blank_length_mm:134.5, weight_grams:112.98, material_id:'10B30' }},
  { customer:'APA Engineering',  part_no:'80-22B',           description:'Hex Flange Drain Plug M14×1.50P',
    part:{ part_type:'BOLT', nominal_diameter_mm:14, thread_pitch_mm:1.5, total_length_mm:34, shank_length_mm:15, head_type:'HEX_FLANGE', socket_type:'HEX_SOCKET', has_flange:true, wire_diameter_mm:12.79, blank_length_mm:34.0, weight_grams:36.97, material_id:'SAE1008' }},
  { customer:'LEDERER',          part_no:'09166140025-01',   description:'Hex Socket Set Screw M14×2.0×25 DIN-916',
    part:{ part_type:'BOLT', nominal_diameter_mm:14, thread_pitch_mm:2.0, total_length_mm:25, head_type:'NONE', socket_type:'HEX_SOCKET', wire_diameter_mm:12.49, blank_length_mm:22.5, material_id:'SCM435' }},
  { customer:'WOOTZWORK',        part_no:'WOOTZ2097793',     description:'Special Hex Bolt M10×22.50 with Serration Gr 8.8',
    part:{ part_type:'BOLT', nominal_diameter_mm:10, thread_pitch_mm:1.5, total_length_mm:22.5, head_type:'HEX_FLANGE', has_flange:true, has_serration:true, wire_diameter_mm:9.475, blank_length_mm:45.5, weight_grams:22.65, material_id:'15B25' }},
  { customer:'Sturdfix',         part_no:'093414-8Z1',       description:'DIN 934 Hex Nut M14×2.0P-6G Gr 8',
    part:{ part_type:'NUT', nominal_diameter_mm:14, thread_pitch_mm:2.0, total_length_mm:12.8, nut_height_mm:12.8, nut_af_mm:22.0, wire_diameter_mm:14.5, material_id:'SAE1022' }},
  { customer:'Sturdfix',         part_no:'TAA27076JB15-5',   description:'DIN 6923 Serrated Flange Nut M8×1.25P Gr 8',
    part:{ part_type:'NUT', nominal_diameter_mm:8, thread_pitch_mm:1.25, total_length_mm:9, nut_height_mm:9, nut_af_mm:14.0, has_flange:true, has_serration:true, wire_diameter_mm:8.5, material_id:'SAE1022' }},
] as any[];

export default function App() {
  const jobs = useStore(s => s.jobs);
  const addJob = useStore(s => s.addJob);
  const updateJob = useStore(s => s.updateJob);

  useEffect(() => {
    if (jobs.length === 0) {
      SEEDS.forEach(s => {
        const { template } = selectTemplate(s.part);
        const machines = matchMachines(s.part, template);
        const best = machines.find((m:any) => m.eligible);
        const id = addJob({ ...s, status:'APPROVED', template, selected_machine:best?.machine_id, engineer_notes:'' });
      });
    }
  }, []); // eslint-disable-line

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/"          element={<Dashboard />} />
          <Route path="/jobs"      element={<Jobs />} />
          <Route path="/jobs/:id"  element={<JobDetail />} />
          <Route path="/new-job"   element={<NewJob />} />
          <Route path="/machines"  element={<Machines />} />
          <Route path="/rules"     element={<Rules />} />
          <Route path="/settings"  element={<Settings />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
